export default __webpack_public_path__ + "static/media/celulose.081581e9.jpg";